import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import SocialZone from "@/pages/SocialZone";
import CreatorZone from "@/pages/CreatorZone";
import BusinessZone from "@/pages/BusinessZone";
import KnowledgeZone from "@/pages/KnowledgeZone";
import StudioZone from "@/pages/StudioZone";
import MarketplaceSuccess from "@/pages/MarketplaceSuccess";
import ProfilePage from "@/pages/ProfilePage";
import PublicProfile from "@/pages/PublicProfile";
import TipSuccess from "@/pages/TipSuccess";
import SubscribeSuccess from "@/pages/SubscribeSuccess";
import CreatorEarnings from "@/pages/CreatorEarnings";
import AnalyticsPage from "@/pages/AnalyticsPage";
import CreatorAnalytics from "@/pages/CreatorAnalytics";
import AdminDigestPage from "@/pages/AdminDigestPage";
import AdminHealthPage from "@/pages/AdminHealthPage";
import CelebrationPage from "@/pages/CelebrationPage";
import AppShell from "@/components/AppShell";
import "@/App.css";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-[#64748B] font-display">Initialising NEXUS…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return <AppShell>{children}</AppShell>;
}

function RootRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/social" element={<Protected><SocialZone /></Protected>} />
      <Route path="/creator" element={<Protected><CreatorZone /></Protected>} />
      <Route path="/marketplace" element={<Protected><BusinessZone /></Protected>} />
      <Route path="/marketplace/success" element={<Protected><MarketplaceSuccess /></Protected>} />
      <Route path="/knowledge" element={<Protected><KnowledgeZone /></Protected>} />
      <Route path="/studio" element={<Protected><StudioZone /></Protected>} />
      <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
      <Route path="/earnings" element={<Protected><CreatorEarnings /></Protected>} />
      <Route path="/analytics" element={<Protected><AnalyticsPage /></Protected>} />
      <Route path="/analytics/posts" element={<Protected><CreatorAnalytics /></Protected>} />
      <Route path="/admin/digest" element={<AdminDigestPage />} />
      <Route path="/admin/health" element={<AdminHealthPage />} />
      <Route path="/u/:userId" element={<PublicProfile />} />
      <Route path="/u/:userId/tip-success" element={<TipSuccess />} />
      <Route path="/u/:userId/subscribe-success" element={<Protected><SubscribeSuccess /></Protected>} />
      <Route path="/m/:creator/:kind/:level" element={<CelebrationPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RootRouter />
        <Toaster
          position="bottom-right"
          theme="light"
          toastOptions={{
            style: {
              background: "rgba(255,255,255,0.92)",
              border: "1px solid rgba(221,42,123,0.25)",
              color: "#0F172A",
              backdropFilter: "blur(20px)",
              boxShadow: "0 10px 30px -10px rgba(15,23,42,0.18)",
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}
